import Swiper from 'swiper';
import { FreeMode } from 'swiper/modules';

import 'swiper/css';
//import 'swiper/css/vertical';

export default function awardsSliders(element, data) {
    new Swiper(element, {
        modules: [FreeMode],
        slidesPerView: 'auto',
        spaceBetween: 0,
        freeMode: {
            enabled: true
        }
    });
}